export default __webpack_public_path__ + "static/media/stake-more-cirus.fac3c11a.svg";